/*
  Bisou Memoire: Header and hero film (Creaeza)

  - Over the hero film the header starts clear with white type; as visitors scroll the big hero
    wordmark glides up and settles in the header while the header calmly turns white.
  - Other pages: a white header with the larger wordmark.
  - Mega menu, search overlay with live suggestions, cart button that opens the theme's cart drawer,
    live cart count.
  - Hero: the film fades in and settles, drifts gently on scroll, pauses when off screen,
    and respects reduced motion.
*/
(function () {
  'use strict';
  if (window.BisouHeader) return;

  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------------- header ---------------- */
  function Header(root) {
    var self = this;
    this.root = root;
    this.bar = root.querySelector('[data-bmh-bar]');
    this.mark = root.querySelector('[data-bmh-mark]');
    this.slot = root.querySelector('[data-bmh-slot]');
    this.menu = root.querySelector('[data-bmh-menu]');
    this.search = root.querySelector('[data-bmh-search]');
    this.counts = [].slice.call(root.querySelectorAll('[data-bmh-count]'));
    this.reduced = reduceMQ.matches;
    this.listeners = [];
    this.ann = document.querySelector('[id$="__announcement-bar"]');

    this.setupHero();
    this.measure();
    this.p = this.target();
    this.render();
    root.classList.add('is-ready');
    this.bind();
    this.bindMenu();
    this.bindSearch();
    this.bindCart();
  }

  Header.prototype.on = function (el, type, fn, opts) {
    el.addEventListener(type, fn, opts || false);
    this.listeners.push([el, type, fn, opts || false]);
  };

  Header.prototype.annBottom = function () {
    var a = this.ann;
    if (!a || a.offsetParent === null) return 0;
    return Math.max(0, a.getBoundingClientRect().bottom);
  };

  Header.prototype.setupHero = function () {
    var h = document.querySelector('[data-bmh-hero]');
    this.hero = null; this.glide = false;
    if (h) {
      // The hero counts only when it is the first section of the page, right under the header.
      var main = document.querySelector('main, #MainContent');
      var first = main && main.querySelector('.shopify-section');
      if (first && first.contains(h)) this.hero = h;
    }
    this.root.classList.toggle('is-hero', !!this.hero);
    if (!this.hero) return;
    this.heroMark = this.hero.querySelector('[data-bmh-hero-mark]');
    this.glide = !this.reduced && !!this.heroMark && this.hero.getAttribute('data-glide') === 'true';
    this.root.classList.toggle('is-glide', this.glide);
    this.hero.classList.toggle('is-glide', this.glide);
  };

  Header.prototype.measure = function () {
    if (!this.glide) return;
    var hm = this.heroMark;
    var r = hm.getBoundingClientRect();
    var lift = this.hero.__bmhLift || 0;
    this.hm = { w: hm.offsetWidth, h: hm.offsetHeight, docCy: r.top + window.pageYOffset - lift + r.height / 2 };
    var sr = this.slot.getBoundingClientRect();
    var restTop = sr.top - this.annBottom();
    this.D = Math.max(1, this.hm.docCy - (restTop + sr.height / 2));
    this.mark.style.width = this.hm.w + 'px';
  };

  Header.prototype.target = function () {
    if (!this.hero) return 1;
    var y = window.pageYOffset;
    if (this.glide) return clamp(y / this.D, 0, 1);
    var hh = this.hero.offsetHeight || window.innerHeight;
    return clamp(y / Math.max(1, hh - this.bar.offsetHeight * 1.5), 0, 1);
  };

  Header.prototype.render = function () {
    var root = this.root, p = this.p, pt = this.target();
    root.style.setProperty('--bmh-top', this.annBottom().toFixed(1) + 'px');
    if (!this.hero) {
      root.style.setProperty('--bmh-solid', '1');
      root.style.setProperty('--bmh-shade', '0');
      root.style.setProperty('--bmh-dark', '1');
      root.classList.remove('is-light');
      return;
    }
    var solid = smooth(0.62, 0.98, pt);
    root.style.setProperty('--bmh-solid', solid.toFixed(3));
    root.style.setProperty('--bmh-shade', (1 - solid).toFixed(3));
    root.classList.toggle('is-light', solid < 0.5 && !root.classList.contains('menu-open'));
    if (!this.glide) {
      root.style.setProperty('--bmh-dark', solid.toFixed(3));
      return;
    }
    var sr = this.slot.getBoundingClientRect();
    var scx = sr.left + sr.width / 2, scy = sr.top + sr.height / 2;
    var f = p + p * p - p * p * p;
    var cy = scy + this.D * (1 - f);
    var k = 1 + (sr.width / this.hm.w - 1) * smooth(0, 1, p);
    this.mark.style.transform = 'translate3d(' + (scx - this.hm.w / 2).toFixed(2) + 'px,' + (cy - this.hm.h / 2).toFixed(2) + 'px,0) scale(' + k.toFixed(4) + ')';
    root.style.setProperty('--bmh-dark', smooth(0.5, 0.92, p).toFixed(3));
  };

  Header.prototype.loop = function () {
    var self = this;
    if (this.raf) return;
    var step = function () {
      self.raf = 0;
      var t = self.target();
      self.p += (t - self.p) * (self.glide ? 0.2 : 1);
      if (Math.abs(t - self.p) < 0.0006) self.p = t;
      self.render();
      if (self.p !== t) self.raf = requestAnimationFrame(step);
    };
    this.raf = requestAnimationFrame(step);
  };

  Header.prototype.bind = function () {
    var self = this;
    this.on(window, 'scroll', function () { self.loop(); }, { passive: true });
    var onResize = function () {
      cancelAnimationFrame(self.resizeRaf);
      self.resizeRaf = requestAnimationFrame(function () {
        self.measure();
        self.p = self.target();
        self.render();
      });
    };
    this.on(window, 'resize', onResize);
    this.on(window, 'load', onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(onResize);
  };

  /* ---------- scroll lock shared by menu and search ---------- */
  Header.prototype.lock = function (on) {
    var html = document.documentElement;
    if (on) {
      var sb = window.innerWidth - html.clientWidth;
      html.classList.add('bmh-lock');
      if (sb > 0) html.style.paddingRight = sb + 'px';
    } else {
      html.classList.remove('bmh-lock');
      html.style.paddingRight = '';
    }
  };

  Header.prototype.trap = function (box, e) {
    var f = [].filter.call(box.querySelectorAll('a[href], button, input, [tabindex="0"]'), function (el) { return !el.disabled && el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  };

  /* ---------- mega menu ---------- */
  Header.prototype.bindMenu = function () {
    var self = this, m = this.menu;
    if (!m) return;
    this.openBtn = this.root.querySelector('[data-bmh-menu-open]');
    this.cats = [].slice.call(m.querySelectorAll('.bmh-mcat'));
    this.panes = [].slice.call(m.querySelectorAll('.bmh-mpane'));
    this.cats.forEach(function (c, i) { c.style.setProperty('--i', i); });
    var lastPointer = 'mouse', lastDown = 0, wasOn = false;
    this.on(this.openBtn, 'click', function () { self.menuOpen ? self.closeMenu() : self.openMenu(); });
    this.on(m, 'pointerdown', function (e) {
      lastPointer = e.pointerType; lastDown = Date.now();
      var c = e.target.closest && e.target.closest('.bmh-mcat');
      wasOn = !!(c && c.classList.contains('is-on'));
    });
    this.cats.forEach(function (c) {
      var i = Number(c.getAttribute('data-c'));
      self.on(c, 'pointerenter', function (e) { if (e.pointerType === 'mouse') self.pick(i); });
      // Keyboard focus shows the category; a tap is handled on click below.
      self.on(c, 'focus', function () { if (Date.now() - lastDown > 600) self.pick(i); });
      self.on(c, 'click', function (e) {
        // On touch screens the first tap opens the category's panel, the second tap visits it.
        if (lastPointer !== 'mouse' && Date.now() - lastDown < 1500 && !wasOn) { e.preventDefault(); self.pick(i); wasOn = true; }
      });
    });
    this.on(m, 'click', function (e) { if (e.target.closest('[data-bmh-menu-close]')) self.closeMenu(); });
    this.on(m, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeMenu(); }
      else if (e.key === 'Tab') self.trap(m, e);
    });
  };

  Header.prototype.pick = function (i) {
    this.cats.forEach(function (c) { c.classList.toggle('is-on', Number(c.getAttribute('data-c')) === i); });
    this.panes.forEach(function (p) { p.classList.toggle('is-on', Number(p.getAttribute('data-c')) === i); });
  };

  Header.prototype.openMenu = function (i) {
    var self = this, m = this.menu;
    if (!m || this.menuOpen) return;
    if (this.searchOpen) this.closeSearch(true);
    this.menuOpen = true;
    clearTimeout(this.menuTimer);
    m.hidden = false;
    this.pick(typeof i === 'number' ? i : 0);
    this.root.classList.add('menu-open');
    this.openBtn.setAttribute('aria-expanded', 'true');
    this.lock(true);
    requestAnimationFrame(function () {
      m.classList.add('is-open');
      var c = m.querySelector('[data-bmh-menu-close]');
      if (c) c.focus({ preventScroll: true });
    });
  };

  Header.prototype.closeMenu = function () {
    var self = this, m = this.menu;
    if (!m || !this.menuOpen) return;
    this.menuOpen = false;
    m.classList.remove('is-open');
    this.root.classList.remove('menu-open');
    this.openBtn.setAttribute('aria-expanded', 'false');
    this.render();
    this.menuTimer = setTimeout(function () { m.hidden = true; self.lock(false); }, this.reduced ? 150 : 500);
    try { this.openBtn.focus({ preventScroll: true }); } catch (e) {}
  };

  /* ---------- search ---------- */
  Header.prototype.bindSearch = function () {
    var self = this, s = this.search;
    if (!s) return;
    this.searchBtn = this.root.querySelector('[data-bmh-search-open]');
    this.q = s.querySelector('[data-bmh-q]');
    this.results = s.querySelector('[data-bmh-results]');
    this.allLink = s.querySelector('[data-bmh-all]');
    this.popular = s.querySelector('[data-bmh-popular]');
    if (this.popular && !this.popular.querySelector('a')) this.popular.hidden = true;
    this.on(this.searchBtn, 'click', function () { self.searchOpen ? self.closeSearch() : self.openSearch(); });
    this.on(s, 'click', function (e) {
      if (e.target === s || e.target.closest('[data-bmh-search-close]')) self.closeSearch();
    });
    this.on(s, 'keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeSearch(); }
      else if (e.key === 'Tab') self.trap(s, e);
    });
    this.on(this.q, 'input', function () {
      clearTimeout(self.qTimer);
      self.qTimer = setTimeout(function () { self.suggest(self.q.value.trim()); }, 220);
    });
  };

  Header.prototype.openSearch = function () {
    var self = this, s = this.search;
    if (!s || this.searchOpen) return;
    if (this.menuOpen) this.closeMenu();
    this.searchOpen = true;
    clearTimeout(this.searchTimer);
    s.hidden = false;
    this.root.classList.add('search-open');
    this.searchBtn.setAttribute('aria-expanded', 'true');
    this.lock(true);
    requestAnimationFrame(function () { s.classList.add('is-open'); self.q.focus({ preventScroll: true }); });
  };

  Header.prototype.closeSearch = function (quiet) {
    var self = this, s = this.search;
    if (!s || !this.searchOpen) return;
    this.searchOpen = false;
    s.classList.remove('is-open');
    this.root.classList.remove('search-open');
    this.searchBtn.setAttribute('aria-expanded', 'false');
    this.searchTimer = setTimeout(function () { s.hidden = true; if (!self.menuOpen) self.lock(false); }, this.reduced ? 150 : 500);
    if (!quiet) { try { this.searchBtn.focus({ preventScroll: true }); } catch (e) {} }
  };

  Header.prototype.suggest = function (q) {
    var self = this;
    if (this.ctrl) { try { this.ctrl.abort(); } catch (e) {} }
    if (q.length < 2) {
      this.results.innerHTML = '';
      this.allLink.hidden = true;
      if (this.popular) this.popular.hidden = !this.popular.querySelector('a');
      return;
    }
    var base = this.root.getAttribute('data-suggest') || '/search/suggest';
    var cur = this.root.getAttribute('data-currency') || '';
    this.ctrl = window.AbortController ? new AbortController() : null;
    var url = base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin', signal: this.ctrl ? this.ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (self.popular) self.popular.hidden = true;
        self.allLink.href = (self.allLink.getAttribute('href').split('?')[0]) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
        self.allLink.hidden = false;
        if (!list.length) { self.results.innerHTML = '<p class="bmh-search__none">' + esc('No match for “' + q + '”') + '</p>'; return; }
        self.results.innerHTML = list.map(function (p, i) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = String(p.price || '').replace(/\.00$/, '');
          return '<a class="bmh-sr" style="--i:' + i + '" href="' + esc(p.url) + '">' +
            '<span class="bmh-sr__ph">' + (img ? '<img src="' + esc(sized(img, 400)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="bmh-sr__n">' + esc(p.title) + '</span>' +
            (price ? '<span class="bmh-sr__p">' + esc(cur + price) + '</span>' : '') + '</a>';
        }).join('');
      })
      .catch(function () {});
  };

  /* ---------- cart ---------- */
  Header.prototype.themeCartToggle = function () {
    var self = this;
    var t = document.querySelector('#SiteHeader [data-cart-drawer-toggle]');
    if (t) return t;
    return [].filter.call(document.querySelectorAll('[data-cart-drawer-toggle]'), function (el) {
      return !self.root.contains(el) && !el.closest('[data-cart-drawer]');
    })[0] || null;
  };

  Header.prototype.setCount = function (n) {
    this.counts.forEach(function (el) { el.textContent = n; });
  };

  Header.prototype.refreshCount = function () {
    var self = this;
    clearTimeout(this.countTimer);
    this.countTimer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && typeof c.item_count === 'number') self.setCount(c.item_count); })
        .catch(function () {});
    }, 180);
  };

  Header.prototype.bindCart = function () {
    var self = this;
    var link = this.root.querySelector('[data-bmh-cart]');
    if (link) {
      this.on(link, 'click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        var t = self.themeCartToggle();
        if (t) { e.preventDefault(); t.click(); }
      });
    }
    var qty = document.querySelector('[data-cart-items-qty]');
    if (qty && window.MutationObserver) {
      this.mo = new MutationObserver(function () { self.refreshCount(); });
      this.mo.observe(qty, { childList: true, characterData: true, subtree: true, attributes: true });
    }
    this.on(document, 'bisou:cart-changed', function () { self.refreshCount(); });
    this.on(window, 'pageshow', function (e) { if (e.persisted) self.refreshCount(); });
  };

  // Any add-to-cart or cart change on the page refreshes the count.
  if (window.fetch && !window.__bmhFetchHook) {
    window.__bmhFetchHook = true;
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var pr = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        pr.then(function () { document.dispatchEvent(new CustomEvent('bisou:cart-changed')); }).catch(function () {});
      }
      return pr;
    };
  }

  /* ---------- theme editor ---------- */
  Header.prototype.selectBlock = function (blockId) {
    var el = this.root.querySelector('[data-shopify-editor-block*="' + blockId + '"]');
    if (!el) return;
    var i = Number(el.getAttribute('data-c'));
    this.openMenu(i);
  };

  Header.prototype.destroy = function () {
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this.listeners = [];
    if (this.mo) this.mo.disconnect();
    cancelAnimationFrame(this.raf);
    this.lock(false);
    if (this.hero) this.hero.classList.remove('is-glide');
  };

  /* ---------------- hero film ---------------- */
  var MODE_KEY = 'bisou-hero-mode';
  function stored(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {}
    return null;
  }

  function Hero(el) {
    var self = this;
    this.el = el;
    this.video = el.querySelector('[data-bmh-video]');
    this.pauseBtn = el.querySelector('[data-bmh-pause]');
    this.media = el.querySelector('[data-bmh-media]');
    this.inner = el.querySelector('[data-bmh-hero-inner]');
    this.still = el.querySelector('[data-bmh-still]');
    this.swap = el.querySelector('[data-bmh-swap]');
    this.canSwap = !!(this.still && this.swap && this.video);
    this.remember = el.getAttribute('data-remember') === 'true';
    this.reduced = reduceMQ.matches;
    this.userPaused = false;
    this.listeners = [];
    var v = this.video;

    // Which view to start with: the visitor's saved choice, else the section default.
    // Visitors who ask for reduced motion start on the still picture.
    var mode = 'film';
    if (this.canSwap) {
      mode = el.getAttribute('data-mode') === 'still' ? 'still' : 'film';
      var saved = this.remember ? stored(MODE_KEY) : null;
      if (saved === 'film' || saved === 'still') mode = saved;
      if (this.reduced) mode = 'still';
    }

    if (this.still) {
      var loaded = function () { self.still.classList.add('is-loaded'); };
      if (this.still.complete && this.still.naturalWidth) loaded();
      else this.on(this.still, 'load', loaded);
    }

    if (v) {
      var playing = function () { el.classList.add('is-playing'); };
      this.on(v, 'playing', playing);
      if (!v.paused && v.readyState > 2) playing();
      // If the film cannot load, the poster stays.
      this.on(v, 'error', function () { el.classList.add('is-still'); });
      if (this.reduced && mode === 'film') {
        // No still picture to show: keep the film paused on its poster; the play button starts it.
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) {}
        el.classList.add('is-still');
        this.userPaused = true;
        this.syncPause();
      }
    }
    this.setMode(mode, { initial: true });

    if (this.pauseBtn && v) {
      this.on(this.pauseBtn, 'click', function () {
        if (v.paused) { self.userPaused = false; self.play(false); }
        else { self.userPaused = true; v.pause(); }
        self.syncPause();
      });
    }
    if (this.swap) {
      [].forEach.call(this.swap.querySelectorAll('[data-mode]'), function (b) {
        self.on(b, 'click', function () { self.setMode(b.getAttribute('data-mode'), { save: true }); });
      });
    }
    // Pause the film while it is off screen, or while the still picture is showing.
    if (v && 'IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) { if (!self.userPaused && self.mode === 'film') self.play(true); }
          else v.pause();
        });
      }, { threshold: 0.05 });
      this.io.observe(el);
    }
    // Get the still picture ready in the background, so switching is instant.
    if (this.canSwap && this.mode === 'film') {
      var warm = function () { setTimeout(function () { self.loadStill(); }, 2500); };
      if (document.readyState === 'complete') warm(); else this.on(window, 'load', warm);
    }
    if (!this.reduced) {
      this.on(window, 'scroll', function () { self.queue(); }, { passive: true });
      this.frame();
    }
  }
  Hero.prototype.on = Header.prototype.on;
  Hero.prototype.loadStill = function () {
    var i = this.still;
    if (i && !i.getAttribute('src') && i.getAttribute('data-src')) i.setAttribute('src', i.getAttribute('data-src'));
  };
  Hero.prototype.play = function (auto) {
    var self = this, v = this.video;
    if (!v) return;
    if (v.preload !== 'auto') v.preload = 'auto';
    var p = v.play();
    if (p && p.catch) p.catch(function (err) {
      if (err && err.name === 'AbortError') return; // interrupted by a pause: nothing to do
      // Autoplay blocked (for example iPhone Low Power Mode) or the film can't play:
      // show the still picture when there is one, so the hero never looks stuck. Film plays it with a tap.
      if (auto && self.canSwap && self.mode === 'film') self.setMode('still', { fallback: true });
      else self.el.classList.add('is-still');
    });
  };
  Hero.prototype.syncPause = function () {
    var b = this.pauseBtn, paused = this.userPaused;
    this.el.classList.toggle('is-paused', paused);
    if (b) b.setAttribute('aria-label', paused ? (b.getAttribute('data-label-play') || 'Play film') : (b.getAttribute('data-label-pause') || 'Pause film'));
  };
  Hero.prototype.setMode = function (m, o) {
    o = o || {};
    if (!this.canSwap) m = 'film';
    var v = this.video, changed = m !== this.mode;
    this.mode = m;
    this.el.setAttribute('data-mode', m);
    if (this.swap) [].forEach.call(this.swap.querySelectorAll('[data-mode]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false');
    });
    if (m === 'still') {
      this.loadStill();
      if (v) { v.removeAttribute('autoplay'); try { v.pause(); } catch (e) {} }
    } else if (v && (o.initial ? !this.userPaused : true)) {
      if (!o.initial) { this.userPaused = false; this.syncPause(); }
      if (o.initial || changed || v.paused) this.play(!!o.initial);
    }
    if (o.save && this.remember) stored(MODE_KEY, m);
  };
  Hero.prototype.queue = function () {
    var self = this;
    if (this.raf) return;
    this.raf = requestAnimationFrame(function () { self.raf = 0; self.frame(); });
  };
  Hero.prototype.frame = function () {
    var h = this.el.offsetHeight || window.innerHeight;
    var y = clamp(window.pageYOffset - (this.el.offsetTop || 0), 0, h);
    if (y >= h && this.lastY >= h) return;
    this.lastY = y;
    var lift = -y * 0.12;
    this.el.__bmhLift = lift;
    this.el.style.setProperty('--bmhero-y', (y * 0.22).toFixed(1) + 'px');
    this.el.style.setProperty('--bmhero-fade', (1 - smooth(0, h * 0.45, y)).toFixed(3));
    this.el.style.setProperty('--bmhero-lift', lift.toFixed(1) + 'px');
  };
  Hero.prototype.destroy = function () {
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    if (this.io) this.io.disconnect();
  };

  /* ---------------- boot ---------------- */
  function init(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-bmh-hero]'), function (el) { if (!el.__bmhHero) el.__bmhHero = new Hero(el); });
    [].forEach.call(document.querySelectorAll('[data-bmh]'), function (el) {
      if (el.__bmh) { el.__bmh.destroy(); }
      el.__bmh = new Header(el);
    });
  }

  window.BisouHeader = { init: init, Header: Header, Hero: Hero };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-bmh]'), function (el) { if (el.__bmh) el.__bmh.destroy(); el.__bmh = null; });
    [].forEach.call(e.target.querySelectorAll('[data-bmh-hero]'), function (el) { if (el.__bmhHero) el.__bmhHero.destroy(); el.__bmhHero = null; });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest && e.target.closest('[data-bmh]');
    if (el && el.__bmh) el.__bmh.selectBlock(e.detail && e.detail.blockId);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target.closest && e.target.closest('[data-bmh]');
    if (el && el.__bmh) el.__bmh.closeMenu();
  });
})();